export default {
  "content": "<path d=\"M16.459 7.29l-2.728 3.82h2.016v1.75h-2.84v1.222h2.84v1.75h-2.84v2.099h-1.75v-2.099H8.313v-1.75h2.842v-1.223H8.314v-1.75h2.016L7.603 7.29l1.423-1.018 3.004 4.205 3.005-4.205L16.46 7.29z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};